import axios, { AxiosResponse } from "axios";
import { captureEvent, setExtra } from "@sentry/react";

import { getPublicToken } from "./getPublicToken";
import { getBaseApiUrl } from "./getBaseApiUrl";

export const client = axios.create({
  baseURL: getBaseApiUrl(),
});

client.interceptors.request.use(async (config) => {
  if (!config.headers.token && config.url !== "/authenticate/json/v2") {
    const token = await getPublicToken(client);

    config.headers.token = token;
    config.headers.limit = 100000;
  }

  return config;
});

client.interceptors.response.use(undefined, (error) => {
  const response = error.response as AxiosResponse<{
    exception: {
      type: string;
      message: string;
    };
  }>;

  setExtra("ERROR", error);
  setExtra("RESPONSE", response?.data);
  captureEvent({
    message: response?.status ?
        `${response?.status} ${response.data?.exception?.type} ${response.data?.exception?.message}`
        : `${error.message}`,
  });

  return Promise.reject(error);
});
